/**
 * Large UPS per-instance editor — placeholders for the 7 large UPS fields (#996 Phase 4).
 * Mirrors coolingSystemRequirementsUi (placeholder-only; large UPS has no per-instance
 * dropdown option lists). Placeholder text reuses labels already shown in the live
 * Facility Power / Large UPS card.
 */

export const LARGE_UPS_PLACEHOLDERS = {
  description: 'Enter description',
  existingSiteProtectedByLargeKwUps: '',
  modelOfExistingUps: 'Enter model of existing UPS',
  levelOfRedundancy: 'Enter level of redundancy',
  requiredRedundancyForUps: 'Enter required redundancy',
  batteryChemistry: 'Enter battery chemistry',
  batteryRuntimeRequiredMin: 'Enter battery runtime required (min)',
} as const;
